import { render, staticRenderFns } from "./RadioQuiz.vue?vue&type=template&id=32ef0f3c&"
import script from "./RadioQuiz.vue?vue&type=script&lang=js&"
export * from "./RadioQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports